module.exports = __webpack_public_path__ + "static/watchOne@2x-33372ea0b9afac78c730c489530fa703.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/watchOne@2x.png
// module id = 2626
// module chunks = 168707334958949